@if (!titleChain) {
  <div class="cm-title">
    {{ title }}
  </div>
}

@if (titleChain) {
  <div class="cm-title">
    @for (title of titleChain; track title; let last = $last; let first = $first) {
      <div
        class="title-item"
        [class.primary]="last"
        >
        @if (!first) {
          <i class="material-icons" [class.primary]="last">chevron_right</i
            >
            }<span>
            {{ title  }}
          </span>
        </div>
      }
    </div>
  }
